import { CustomImage } from '..';
import styles from './Carousel.module.css';

export const Carousel = ({
  className,
  carouselImages,
}: {
  className?: string;
  carouselImages: {
    mobileSrc: string;
    desktopSrc: string;
    caption: string;
  }[];
}) => {
  return (
    <div className={`${styles.root} u-hide-scrollbar${className ? ` ${className}` : ''}`}>
      {carouselImages.map((carouselImage, index) => {
        return (
          <div className={styles.carouselImage} key={`carousel-image-${index}`}>
            {/* Both crops render (lazy) and CSS picks one at 992px so SSR
                HTML is width-correct — useWindowSize is 0 on SSR. */}
            <CustomImage
              className="img-desktop"
              src={`web_v2/hero/hero-categories/desktop/${carouselImage.desktopSrc}`}
              fill
              alt={carouselImage.caption}
            />
            <CustomImage
              className="img-mobile"
              src={`web_v2/hero/hero-categories/mobile/${carouselImage.mobileSrc}`}
              fill
              alt={carouselImage.caption}
            />
            <div className={styles.textContainer}>
              <p>{carouselImage.caption}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
